import moment from "moment";

export const formatTime12h = (time) => {
    if (!time) return '';
    const t = time.toString().padStart(4, '0');
    return moment(t, 'HHmm').format('h:mm A');
};

export const formatCurrency = (amount) => `$${Number(amount).toFixed(2)}`;

export const formatInvoiceDate = (date) => {
    if (date == null || date === "") return "-";
    const m = moment(date);
    return m.isValid() ? m.format("DD MMM YYYY") : "-";
};

/** Replaced by a newer invoice (`status` = superseded); omit from student totals and lists. */
export const isSupersededInvoice = (inv) =>
    String(inv?.status ?? "").toLowerCase() === "superseded";

export const getParticipantFullName = (user) => {
    const full = user?.user_metadata?.full_name || user?.user_metadata?.name || "";
    if (full && typeof full === "string" && full.trim()) return full.trim();
    const email = user?.email || "";
    if (email) {
        const beforeAt = email.split("@")[0] || "";
        const name = beforeAt.replace(/[._0-9]+/g, " ").trim() || beforeAt;
        return name
            ? name.split(/\s+/).map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(" ")
            : "Participant";
    }
    return "Participant";
};

export const getGreetingName = (user) => {
    const full = user?.user_metadata?.full_name || user?.user_metadata?.name || "";
    if (full && typeof full === "string" && full.trim()) {
        const first = full.trim().split(/\s+/)[0];
        return first.charAt(0).toUpperCase() + first.slice(1).toLowerCase();
    }
    const email = user?.email || "";
    if (email) {
        const beforeAt = email.split("@")[0] || "";
        const name = beforeAt.replace(/[._0-9]+/g, " ").trim().split(/\s+/)[0] || beforeAt;
        return name ? name.charAt(0).toUpperCase() + name.slice(1).toLowerCase() : "there";
    }
    return "there";
};

export const getTimeOfDayGreeting = () => {
    const hour = moment().hour();
    if (hour < 12) return "Good morning";
    if (hour < 17) return "Good afternoon";
    return "Good evening";
};

export const getDisplayDocumentName = (title) => {
    if (!title) return '';
    return title.replace(/\s*-\s*.*$/, '').trim();
};

export const getGoogleMapsSearchUrl = (address, postalCode) => {
    const parts = [address, "Singapore", postalCode].filter(Boolean);
    if (parts.length === 0) return null;
    const fullAddress = parts.join(", ");
    return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}`;
};

export const getOrdinalSuffix = (num) => {
    const j = num % 10;
    const k = num % 100;
    if (j === 1 && k !== 11) return "st";
    if (j === 2 && k !== 12) return "nd";
    if (j === 3 && k !== 13) return "rd";
    return "th";
};

export const getCertStatus = (cert) => {
    if (!cert?.start_date || !cert?.end_date) return { status: 'unknown', label: '\u2014', bg: 'gray.500', color: 'white' };
    const today = moment().startOf('day');
    const start = moment(cert.start_date).startOf('day');
    const end = moment(cert.end_date).startOf('day');
    if (end.isBefore(today)) return { status: 'completed', label: 'Completed', bg: 'purple.500', color: 'white' };
    if (start.isAfter(today)) {
        const days = start.diff(today, 'days');
        const label = days === 1 ? 'In 1 day' : `In ${days} days`;
        return { status: 'upcoming', label, bg: 'blue.500', color: 'white' };
    }
    return { status: 'ongoing', label: 'Ongoing', bg: 'green.500', color: 'white' };
};

export const getModuleStatus = (module) => {
    if (!module?.start_date || !module?.end_date) return { label: '\u2014', bg: 'gray.500', color: 'white' };
    const today = moment().startOf('day');
    const start = moment(module.start_date).startOf('day');
    const end = moment(module.end_date).startOf('day');
    if (end.isBefore(today)) return { label: 'Completed', bg: 'purple.500', color: 'white' };
    if (start.isAfter(today)) {
        const days = start.diff(today, 'days');
        const label = days === 1 ? 'In 1 day' : `In ${days} days`;
        return { label, bg: 'blue.500', color: 'white' };
    }
    return { label: 'Ongoing', bg: 'green.500', color: 'white' };
};

export const getDueInBadge = (invoice) => {
    const isPaid = invoice.status === "paid" || invoice.status === "Paid";
    if (isPaid) return null;
    const due = moment(invoice.due_date).startOf("day");
    if (!invoice.due_date || !due.isValid()) return null;
    const today = moment().startOf("day");
    const days = due.diff(today, "days");
    if (days > 1) return { label: `In ${days} days`, bg: "blue.500", color: "white" };
    if (days === 1) return { label: "In 1 day", bg: "blue.500", color: "white" };
    if (days === 0) return { label: "Today", bg: "orange.500", color: "white" };
    if (days === -1) return { label: "1 day overdue", bg: "red.500", color: "white" };
    return { label: `${Math.abs(days)} days overdue`, bg: "red.500", color: "white" };
};
